import { gql } from "@apollo/client";

export const DELETE_FEED_CURVE = gql`
  mutation DeleteFeedCurve($domain: String!, $deleteId: Int!) {
    feedCurve {
      delete(domain: $domain, id: $deleteId) {
        code
        success
        message
      }
    }
  }
`;
export interface DeleteFeedCurve {
  feedCurve: {
    delete: {
      code: string;
      success: boolean;
      message: string;
    }
  }
}